(() => {
 'use strict';
 if (window.yndShoppingDialogsInitialized) return;
 window.yndShoppingDialogsInitialized = true;
 const search = document.getElementById('ynd-search-dialog');
 const cart = document.getElementById('ynd-cart-dialog');
 const sameOrigin = value => {
  if (typeof value !== 'string' || !value.trim()) return null;
  try { const url = new URL(value, location.origin); return url.origin === location.origin && /^https?:$/.test(url.protocol) ? url : null; } catch { return null; }
 };
 const nativeRoot = sameOrigin(document.documentElement.dataset.yndRoot || '/');
 const root = nativeRoot?.pathname.replace(/\/?$/, '/') || '/';
 const plainClick = event => event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
 // Search results are native Shopify predictions; never render arbitrary response HTML or infer prices.
 if (search) {
  const form = search.querySelector('[data-dialog-search]');
  const input = form?.querySelector('[name="q"]');
  const status = search.querySelector('#ynd-search-status');
  const results = search.querySelector('[data-dialog-search-results]');
  const all = search.querySelector('[data-dialog-search-all]');
  let timer, request, revision = 0;
  const cancel = () => { clearTimeout(timer); request?.abort(); revision++; results.setAttribute('aria-busy', 'false'); };
  const updateAll = query => {
   const url = sameOrigin(form.action);
   if (!url) return;
   url.searchParams.set('q', query); url.searchParams.set('type', 'product');
   all.href = url.pathname + url.search; all.hidden = !query;
  };
  const reset = () => {
   cancel(); results.replaceChildren(); updateAll(''); status.textContent = 'Start with a style, color or occasion.';
  };
  async function runSearch() {
   cancel();
   const query = input.value.trim();
   if (!query) { reset(); return; }
   updateAll(query); results.replaceChildren(); status.textContent = 'Searching the collection…'; results.setAttribute('aria-busy', 'true');
   const version = revision, controller = new AbortController(); request = controller;
   const timeout = setTimeout(() => controller.abort(), 12000);
   try {
    const url = sameOrigin(search.dataset.predictiveUrl || `${root}search/suggest`);
    if (!url) throw new Error('Invalid search route');
    url.pathname = url.pathname.replace(/\.json$/, '') + '.json';
    url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '6');
    const response = await fetch(url.pathname + url.search, {signal:controller.signal, credentials:'same-origin', headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Search unavailable');
    const data = await response.json();
    const products = data.resources?.results?.products;
    if (!Array.isArray(products)) throw new Error('Invalid search response');
    if (version !== revision || !search.open) return;
    let count = 0;
    products.slice(0, 6).forEach(product => {
     const productUrl = sameOrigin(product.url);
     if (!productUrl || typeof product.title !== 'string' || !product.title.trim()) return;
     const link = document.createElement('a'); link.className = 'dialog-search-result'; link.href = productUrl.pathname + productUrl.search;
     const imageUrl = typeof product.image === 'string' ? product.image : product.featured_image?.url;
     if (imageUrl) {
      try {
       const url = new URL(imageUrl, location.origin);
       if (url.protocol === 'https:' || url.origin === location.origin) {
        const image = document.createElement('img'); image.src = url.href; image.alt = ''; image.width = 62; image.height = 80; image.loading = 'lazy'; link.append(image);
       }
      } catch {}
     }
     const title = document.createElement('span'); title.textContent = product.title; link.append(title); results.append(link); count++;
    });
    status.textContent = count ? `${count} suggested ${count === 1 ? 'style' : 'styles'}. View all results for more.` : 'No suggested styles found. Try another search or view all results.';
   } catch {
    if (version === revision && search.open) status.textContent = 'Suggestions are unavailable. View all results to continue your search.';
   } finally {
    clearTimeout(timeout);
    if (version === revision) results.setAttribute('aria-busy', 'false');
   }
  }
  input?.addEventListener('input', event => {
   cancel(); results.replaceChildren(); const query = input.value.trim(); updateAll(query);
   if (!query) { reset(); return; }
   status.textContent = 'Searching the collection…';
   if (!event.isComposing) timer = setTimeout(runSearch, 240);
  });
  input?.addEventListener('compositionend', () => { clearTimeout(timer); timer = setTimeout(runSearch, 240); });
  form?.addEventListener('submit', event => { event.preventDefault(); runSearch(); });
  search.addEventListener('close', cancel);
  search.addEventListener('ynd:utility-open', () => { if (input.value.trim()) runSearch(); });
 }
 // Cart HTML comes from Liquid using the same hold guard and money filters as the full cart.
 // Reads are abortable and revision-checked. Mutations are serialized and NEVER retried automatically.
 if (cart) {
  const content = cart.querySelector('[data-cart-dialog-content]');
  const status = cart.querySelector('[data-cart-dialog-status]');
  const error = cart.querySelector('[data-cart-dialog-error]');
  const retry = cart.querySelector('[data-cart-dialog-retry]');
  const section = 'ynd-cart-dialog-content';
  let readController, revision = 0, mutating = false;
  const cartUrl = sameOrigin(cart.dataset.cartUrl || `${root}cart`);
  const changeUrl = sameOrigin(cart.dataset.cartChangeUrl || `${root}cart/change`);
  const setError = message => { error.textContent = message; error.hidden = !message; };
  const setBusy = busy => {
   content.setAttribute('aria-busy', String(busy)); content.inert = busy;
   content.querySelectorAll('[data-dialog-checkout]').forEach(button => {
    button.disabled = busy || button.closest('[data-cart-dialog-render]')?.dataset.cartHeld !== 'false';
   });
  };
  const stopRead = () => { revision++; readController?.abort(); };
  const updateCount = count => document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = String(count); node.hidden = count === 0; });
  const render = (html, focusKey) => {
   if (typeof html !== 'string') throw new Error('Missing cart section');
   const parsed = new DOMParser().parseFromString(html, 'text/html');
   const source = parsed.querySelector('[data-cart-dialog-render]');
   const count = Number(source?.dataset.cartItemCount);
   if (!source || !Number.isInteger(count) || count < 0 || !['true', 'false'].includes(source.dataset.cartHeld)) throw new Error('Invalid cart section');
   source.querySelectorAll('script').forEach(node => node.remove());
   updateCount(count);
   if (!cart.open) return;
   content.replaceChildren(document.importNode(source, true)); setBusy(false); retry.hidden = true;
   status.textContent = count ? `${count} ${count === 1 ? 'item' : 'items'} in your bag.` : '';
   if (focusKey) {
    const line = [...content.querySelectorAll('[data-cart-line-key]')].find(node => node.dataset.cartLineKey === focusKey);
    (line?.querySelector('[data-cart-line-quantity]') || content.querySelector('[data-cart-line-quantity], a') || cart.querySelector('[data-close-utility]'))?.focus({preventScroll:true});
   }
  };
  async function loadCart({message = '', focusKey = ''} = {}) {
   if (mutating) { status.textContent = 'Updating your bag…'; setBusy(true); return; }
   stopRead();
   const version = revision, controller = new AbortController(); readController = controller;
   if (document.activeElement === retry) cart.querySelector('[data-close-utility]')?.focus({preventScroll:true});
   setError(message); retry.hidden = true; status.textContent = 'Loading your bag…'; setBusy(true);
   const timeout = setTimeout(() => controller.abort(), 12000);
   try {
    if (!cartUrl) throw new Error('Invalid cart route');
    const url = new URL(cartUrl); url.searchParams.set('section_id', section);
    const response = await fetch(url.pathname + url.search, {signal:controller.signal, cache:'no-store', credentials:'same-origin', headers:{Accept:'text/html'}});
    if (!response.ok) throw new Error('Bag unavailable');
    const html = await response.text();
    if (version !== revision || !cart.open) return;
    render(html, focusKey);
   } catch {
    if (version !== revision || !cart.open) return;
    content.replaceChildren(); setBusy(false); status.textContent = '';
    setError(message || 'Your bag couldn’t be loaded. Try again or open your full bag.'); retry.hidden = false;
   } finally { clearTimeout(timeout); }
  }
  async function changeLine(key, quantity) {
   if (mutating || content.inert || !cart.open) return;
   stopRead(); mutating = true; setBusy(true); setError(''); retry.hidden = true; status.textContent = 'Updating your bag…';
   const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 20000);
   let html, message = '';
   try {
    if (!cartUrl || !changeUrl) throw new Error('Invalid cart route');
    const url = new URL(changeUrl); url.pathname = url.pathname.replace(/\.js$/, '') + '.js';
    const response = await fetch(url.pathname, {method:'POST', credentials:'same-origin', signal:controller.signal, headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({id:key, quantity, sections:[section], sections_url:cartUrl.pathname})});
    const data = await response.json();
    if (!response.ok) {
     const detail = typeof data.description === 'string' ? data.description.slice(0, 350) : '';
     message = detail || 'This quantity couldn’t be updated. Please review your bag and try again.';
    } else {
     html = data.sections?.[section];
    }
   } catch {
    message = 'We couldn’t confirm this update. Review your bag before trying again.';
   } finally { clearTimeout(timeout); mutating = false; }
   // A close never implies a cancelled server mutation. Reopening waits for this result.
   if (html) {
    try { render(html, key); setError(message); return; } catch {}
   }
   if (cart.open) await loadCart({message, focusKey:key});
  }
  cart.addEventListener('ynd:utility-open', () => loadCart());
  cart.addEventListener('close', () => { stopRead(); });
  retry.addEventListener('click', () => loadCart());
  content.addEventListener('keydown', event => {
   if (event.key === 'Enter' && event.target.matches('[data-cart-line-quantity]')) {
    event.preventDefault(); event.target.dispatchEvent(new Event('change', {bubbles:true}));
   }
  });
  content.addEventListener('change', event => {
   const input = event.target.closest('[data-cart-line-quantity]');
   if (!input || mutating || content.inert) return;
   const quantity = Number(input.value), previous = Number(input.dataset.cartCurrentQuantity);
   if (!input.value.trim() || !Number.isInteger(quantity) || quantity < 1 || !input.checkValidity()) {
    input.reportValidity(); input.value = String(previous); setError('Please choose a valid quantity. Use Remove to take this style out of your bag.'); return;
   }
   if (quantity !== previous) changeLine(input.closest('[data-cart-line-key]').dataset.cartLineKey, quantity);
  });
  content.addEventListener('click', event => {
   const remove = event.target.closest('[data-cart-line-remove]');
   if (!remove || !plainClick(event)) return;
   event.preventDefault(); changeLine(remove.closest('[data-cart-line-key]').dataset.cartLineKey, 0);
  });
  content.addEventListener('submit', event => {
   const checkout = event.submitter?.matches('[data-dialog-checkout]');
   if (!checkout || mutating || content.inert || content.querySelector('[data-cart-dialog-render]')?.dataset.cartHeld !== 'false') event.preventDefault();
  });
  window.addEventListener('pageshow', event => { if (event.persisted && cart.open) loadCart(); });
 }
})();
